import { SET_MARKET_GROUP } from '../../constants';

export const ConfigReducer = (state, action) => {
    switch (action.type) {
        case SET_MARKET_GROUP:
            return {
                ...state,
                marketGroup: action.payload,
            };
        default:
            return state;
    }
};
